export const federalLawsSelectOptions = [
  {
    id: '131',
    value: '131',
    label: '131 ФЗ',
  },
  {
    id: '184',
    value: '184',
    label: '414 ФЗ (бывший 184 ФЗ)',
  },
  {
    id: '248',
    value: '248',
    label: '248 ФЗ',
  },
  {
    id: '294',
    value: '294',
    label: '294 ФЗ',
  },
  {
    id: '68',
    value: '68',
    label: '68 ФЗ',
  },
];
